const generateTwitterLink = ({ text, url }) => {
  const params = [
    `text=${encodeURI(text)}`,
    `url=${encodeURI(url)}`,
  ];
  return `https://twitter.com/intent/tweet?${params.join('&')}`;
};

export default generateTwitterLink;
